import React, { useContext, useEffect, useState, useMemo } from "react";
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography';
import { useNavigate, Link } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container'
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import '@fontsource/roboto/300.css';
import { useHistory } from 'react-router-dom';
import api from '../../services/api';
import { Cookies } from 'react-cookie';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { makeStyles } from '@mui/styles';
import olho from '../../assets/img/olho.svg';
import { formatarTelefone, formatarDataHora, numberWithCommas, identificacaoUsuarioLogado } from '../../utils';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import DetalhesMeuPedido from '../../components/Meu_Pedido/Meu_Pedido';
import Backdrop from '@mui/material/Backdrop';
import { MyContext } from '../../context/MyContext';
import CircularProgress from '@mui/material/CircularProgress';
import * as locales from '@mui/material/locale';
import { useTheme, ThemeProvider, createTheme } from "@mui/material/styles";
import { DataGrid } from '@mui/x-data-grid';
import { BrowserView, MobileView } from 'react-device-detect';
import { FuncoesDisponiveis } from '../../context/Funcoes';

export default function (props) {
    const { showModalMeuPedido, setShowModalMeuPedido } = useContext(MyContext);
    const { meusCreditosSelecionados, setMeusCreditosSelecionados } = useContext(MyContext);
    const { destinoPagina, setDestinoPagina } = useContext(MyContext);
    const [meusPedidos, setMeusPedidos] = useState([]);
    const [locale, setLocale] = useState('ptBR');
    const theme = useTheme();
    const themeWithLocale = useMemo(() => createTheme(theme, locales[locale]), [locale, theme]);
    const [meusPedidosPreVendas, setMeusPedidosPreVendas] = useState([]);
    const [retornoApi, setRetornoApi] = useState({});
    const [pedidoSelecionado, setPedidoSelecionado] = useState({});
    const [selectedRows, setSelectedRows] = useState([]);
    const [usuarioLogado, setUsuarioLogado] = useState("");  // Armazena Criptografado o Id e Loja do Cliente
    let navigate = useHistory();

    const toastMensagemError = (message) => toast.error(message,
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

    const { Verificar_Token } = useContext(FuncoesDisponiveis);        

    useEffect(() => {
        const verificar_logados = async () => {        
            if (! await Verificar_Token()){
                setDestinoPagina('meus_pedidos');
                navigate.push('/login');    
            }else{
                setUsuarioLogado(sessionStorage.getItem("id_loja_usuario"));
                var userLogado = identificacaoUsuarioLogado(usuarioLogado);
                if (userLogado != null && userLogado.length == 0) {
                   toastMensagemError("Será Necessário Efetuar Login!");
                   setDestinoPagina("meus_pedidos");
                   navigate.push('/login');
                }
                else {
                   BuscarMinhasCompras(userLogado);
                   if (meusPedidos.preVendas != null) {
                     setMeusPedidosPreVendas(meusPedidos.preVendas);
                   }
               }
            }
        
        }
        verificar_logados();
    }, []);

    const handleOpenModal = () => {
        // setOpen(true);
        setShowModalMeuPedido(true);
    }

    const handleCloseModal = () => {
        // setOpen(false);
        setShowModalMeuPedido(false);
        navigate.push('/meus_pedidos');
    }

    const modalStyle = {
        position: 'absolute',
        top: '8%',
        left: '10%',
        right: "10%",
        overflow: 'scroll',
        height: '100%',
        display: 'block',
        bgcolor: 'background.paper',
        boxShadow: 24
    }

    const modalStyleMobile = {
        position: 'absolute',
        top: '8%',
        left: '1%',
        right: "1%",
        overflow: 'scroll',
        height: '100%',
        display: 'block',
        bgcolor: 'background.paper',
        boxShadow: 24
    }

    const gridStyles = makeStyles((theme) => ({
        container: {
            border: '4px solid green',
            display: 'inline-flex',
        },
        item: { borderRadius: '30px' },
        paper: {
            padding: theme.spacing(2),
            textAlign: 'center',
            color: theme.palette.text.secondary,
        },
    }));

    const columns = [
        {
            field: 'meusPedidos.ids_prevendas + "-" + meusPedidos.ids_prevendas_Loja',
            headerName: 'ID Pedido',
            width: 150,
            editable: false,
            valueGetter: (params) =>
                `${params.row.ids_prevendas + "-" + params.row.ids_prevendas_loja || ''}`,
        },
        {
            field: 'meusPedidos.data',
            headerName: 'Data',
            width: 140,
            editable: false,
            valueGetter: (params) =>
                `${formatarDataHora(params.row.data, 4) || ''}`,
        },
        {
            field: 'meusPedidos.cliente_razao_social',
            headerName: 'Nome',
            width: 312,
            editable: false,
            valueGetter: (params) =>
                `${params.row.cliente_razao_social || ''}`,
        },
        {
            field: 'meusPedidos.total_geral',
            headerName: 'Valor Total',
            width: 120,
            editable: false,
            align: 'right',
            valueGetter: (params) =>
                `${numberWithCommas(params.row.total_geral) || ''}`,
        },
        {
            field: 'meusPedidos.transporte_modelo',
            headerName: 'Tipo de Frete',
            width: 185,
            editable: false,
            valueGetter: (params) =>
                `${params.row.transporte_modelo || ''}`,
        },
        {
            field: 'meusPedidos.transporte_rastreamento',
            headerName: 'Rastreio do Envio',
            width: 205,
            editable: false,
            valueGetter: (params) =>
                `${params.row.transporte_rastreamento || ''}`,
        },
        {
            field: 'image',
            headerName: 'Ver',
            width: 37,
            editable: true,
            renderCell: (params) => <img src={olho} />, // renderCell will render the component
        }
    ];

    function BuscarMinhasCompras(usuarioLogado) {
        var __clienteID = 0;
        var __clienteIDLoja = 0;
        __clienteID = usuarioLogado.split('_')[0];
        __clienteIDLoja = usuarioLogado.split('_')[1];
        
        setDestinoPagina("meus_pedidos");

        api.get(`/Pedidos/MeusPedidosResumido/${__clienteID}/${__clienteIDLoja}`,{ withCredentials: true })
            .then((response) => {                                                
                return response;
            })
            .then((data) => {
                if (data.data === 0) {
                    toastMensagemError("Nenhum Pedido Foi Localizado!");
                    return null;
                }
                else {
                    setMeusPedidos(data.data);
                }
            })
            .catch((error) => {
                if (error == "Error: Network Error") {
                    toastMensagemError("Ops, Alguma Coisa Errada com Nosso Servidor!");
                    return null;
                }
                console.log(error.message)
            });
    }

    const localizedTextsMap = {
        columnMenuUnsort: "Não Ordenado",
        columnMenuSortAsc: "Ordem Crescente",
        columnMenuSortDesc: "Ordem Cecrescente",
        columnMenuFilter: "Filtro",
        columnMenuHideColumn: "Ocultar",
        columnMenuShowColumns: "Mostrar Colunas",
        columnHeaderSortIconLabel: 'Ordenar',
        noRowsLabel: 'Nenhuma Linha',
        footerTotalRows: 'Total de Linhas:',
        filterPanelOperators: 'Operador',
        filterPanelColumns: 'Coluna',
        filterPanelInputLabel: 'Valor',
        filterOperatorContains: 'contém',
        filterOperatorEquals: 'igual',
        filterOperatorStartsWith: 'começa com',
        filterOperatorEndsWith: 'termina com',
        filterOperatorIs: 'é',
        filterOperatorNot: 'não é',
        filterOperatorAfter: 'depois de',
        filterOperatorOnOrAfter: 'igual ou depois',
        filterOperatorBefore: 'antes de',
        filterOperatorOnOrBefore: 'igual ou antes',
        filterOperatorIsEmpty: 'é vazio',
        filterOperatorIsNotEmpty: 'não é vazio',
        filterOperatorIsAnyOf: 'é qualquer um',
        filterPanelInputPlaceholder: 'Pesquisar',
        toolbarFiltersTooltipActive: (count) =>
            count !== 1 ? `${count} filtro ativo` : `${count} filtros ativos`,
        footerTotalVisibleRows: (visibleCount, totalCount) =>
            `${visibleCount.toLocaleString()} de ${totalCount.toLocaleString()}`,

        footerRowSelected: (count) =>
            count !== 1
                ? `${count.toLocaleString()} Linhas Selecionadas`
                : `${count.toLocaleString()} Linha Selecionada`,
    };

    return (
        <>
        <BrowserView>
        {
            (meusPedidos == null
            ?
            <></>
            :
            
            <div>
                <Container maxWidth="lg">
                    <Box minHeight={'450px'} marginTop={'10px'}>
                        <Grid container justifyContent={"center"} spacing={2}>

                            <Grid item xs={12} md={12} classeName={gridStyles}>
                                <div>
                                    <ThemeProvider theme={themeWithLocale}>
                                        {
                                            meusPedidos === null || meusPedidos.length === 0
                                                ?

                                                <CircularProgress color="success">Aguarde...</CircularProgress>

                                                :

                                                <DataGrid
                                                    headerHeight={35}
                                                    autoHeight
                                                    getRowId={(meusPedidos) => meusPedidos.ids_prevendas + '-' + meusPedidos.ids_prevendas_loja}
                                                    rows={meusPedidos}
                                                    onSelectionModelChange={(ids) => {
                                                        const selectedIDs = new Set(ids);
                                                        const [first] = selectedIDs;
                                                        const idSelecionado = Number(first?.split('-')[0]);
                                                        const idLojaSelecionado = Number(first?.split('-')[1]);
                                                        const selectedRows = meusPedidos.filter((obj) => obj.ids_prevendas == idSelecionado && obj.ids_prevendas_loja == idLojaSelecionado);
                                                        if (selectedRows.length > 0) {
                                                            setRetornoApi(selectedRows[0]);
                                                            handleOpenModal();
                                                        }
                                                    }}
                                                    columns={columns}
                                                    pageSize={20}
                                                    rowHeight={34}
                                                    //rowSelection={'single'}
                                                    // checkboxSelection
                                                    // disableSelectionOnClick
                                                    localeText={localizedTextsMap}
                                                    sx={{ fontSize: '12px', fontWeight: 'bold' }}
                                                    selectionModel={meusPedidos[0]}
                                                />
                                        }

                                    </ThemeProvider>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Container >
                <ToastContainer />
                {
                    (showModalMeuPedido ?
                        <div>
                            <Modal
                                aria-labelledby="transition-modal-title"
                                aria-describedby="transition-modal-description"
                                open={setShowModalMeuPedido}
                                onClose={handleCloseModal}
                                closeAfterTransition
                                BackdropComponent={Backdrop}
                                BackdropProps={{
                                    timeout: 500,
                                }}
                            >
                                <Fade in={showModalMeuPedido}>
                                    <Box sx={modalStyle}>
                                        <DetalhesMeuPedido props={retornoApi} />
                                    </Box>
                                </Fade>
                            </Modal>
                        </div>
                        :
                        <div></div>)
                }
            </div > 
        )} 
        </BrowserView>

        <MobileView>
        {
        (meusPedidos == null
            ?
            <></>
            :
            
            <div>
                <Container maxWidth="lg">
                    <Box minHeight={'450px'} marginTop={'10px'}>
                        <Grid container justifyContent={"center"} spacing={2}>

                            <Grid item xs={12} md={12} classeName={gridStyles}>
                                <div>
                                    <ThemeProvider theme={themeWithLocale}>
                                        {
                                            meusPedidos === null || meusPedidos.length === 0
                                                ?

                                                <CircularProgress color="success">Aguarde...</CircularProgress>

                                                :

                                                <DataGrid
                                                    headerHeight={35}
                                                    autoHeight
                                                    getRowId={(meusPedidos) => meusPedidos.ids_prevendas + '-' + meusPedidos.ids_prevendas_loja}
                                                    rows={meusPedidos}
                                                    onSelectionModelChange={(ids) => {
                                                        const selectedIDs = new Set(ids);
                                                        const [first] = selectedIDs;
                                                        const idSelecionado = Number(first?.split('-')[0]);
                                                        const idLojaSelecionado = Number(first?.split('-')[1]);
                                                        const selectedRows = meusPedidos.filter((obj) => obj.ids_prevendas == idSelecionado && obj.ids_prevendas_loja == idLojaSelecionado);
                                                        if (selectedRows.length > 0) {
                                                            setRetornoApi(selectedRows[0]);
                                                            handleOpenModal();
                                                        }
                                                    }}
                                                    columns={columns}
                                                    pageSize={20}
                                                    rowHeight={34}
                                                    //rowSelection={'single'}
                                                    // checkboxSelection
                                                    // disableSelectionOnClick
                                                    localeText={localizedTextsMap}
                                                    sx={{ fontSize: '12px', fontWeight: 'bold' }}
                                                    selectionModel={meusPedidos[0]}
                                                />
                                        }

                                    </ThemeProvider>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Container >
                <ToastContainer />
                {
                    (showModalMeuPedido ?
                        <div>
                            <Modal
                                aria-labelledby="transition-modal-title"
                                aria-describedby="transition-modal-description"
                                open={setShowModalMeuPedido}
                                onClose={handleCloseModal}
                                closeAfterTransition
                                BackdropComponent={Backdrop}
                                BackdropProps={{
                                    timeout: 500,
                                }}
                            >
                                <Fade in={showModalMeuPedido}>
                                    <Box sx={modalStyleMobile}>
                                        <DetalhesMeuPedido props={retornoApi} />
                                    </Box>
                                </Fade>
                            </Modal>
                        </div>
                        :
                        <div></div>)
                }
            </div >        
        ) }
        </MobileView>
        </>
        
    )
}
